/**
 * Created by mgoria on 11/03/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingLocalLambdaExecWrapperException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let MissingLocalLambdaExecWrapperException = exports.MissingLocalLambdaExecWrapperException = function (_Exception) {
  _inherits(MissingLocalLambdaExecWrapperException, _Exception);

  /**
   * @param {String} execWrapperKey
   */
  function MissingLocalLambdaExecWrapperException(execWrapperKey) {
    _classCallCheck(this, MissingLocalLambdaExecWrapperException);

    return _possibleConstructorReturn(this, (MissingLocalLambdaExecWrapperException.__proto__ || Object.getPrototypeOf(MissingLocalLambdaExecWrapperException)).call(this, `Missing local lambda execution wrapper in global.${execWrapperKey}`));
  }

  return MissingLocalLambdaExecWrapperException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/MissingLocalLambdaExecWrapperException.js
// module id = 422
// module chunks = 0